import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { authHeader, debounce } from '../../../../utils';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { ERROR, SET_SUCCESS } from '../../../../store/types';
import TrashIcon from '../../../../components/elements/icons/TrashIcon';
import PencilSquareIcon from '../../../../components/elements/icons/PencilSquareIcon';
import Loader from '../../../../components/elements/Loader';
import EmptyState from '../../../../components/elements/EmptyState';
import ModalDialog from '../../../../components/layouts/ModalDialog';
import EditInvoice from '../../../../components/partials/invoices/EditInvoice';
import AssignInvoice from '../../../../components/partials/invoices/AssignInvoice';
import { clearCreatedInvoiceAssignment, clearUpdatedInvoice, fetchInvoiceAssignments } from '../../../../store/actions/invoicesActions';
import InvoiceAssignmentCard from '../../../../components/partials/invoices/InvoiceAssignmentCard';
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon';
import SearchField from '../../../../components/elements/SearchField';
import AddInvoiceDiscount from '../../../../components/partials/invoices/AddInvoiceDiscount';
import EnablePartPayment from '../../../../components/partials/invoices/EnablePartPayment';
import AssignedInvoice from '../../../../components/partials/invoices/AssignedInvoice';

const Invoice = () => {
  const dispatch = useDispatch()
  const {invoiceId} = useParams()
  const [loading, setLoading] = useState(true);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const invoicesSelector = useSelector(state => state.invoices)

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const headers = authHeader()

          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/invoices/${invoiceId}?expand=fees.fee`, { headers })            

          setInvoiceDetails(response.data.data)
          setLoading(false)
          
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setLoading(false)
        }
    }

    dispatch(fetchInvoiceAssignments(`invoice=${invoiceId}`, 1, 10))

    fetchInvoice()

    if(invoicesSelector.updatedInvoice) {
      dispatch({
        type: SET_SUCCESS,
        payload: 'Invoice updated successfully!'
      })
      dispatch(clearUpdatedInvoice())
    }

    if(invoicesSelector.createdInvoiceAssignment) {
      dispatch({
        type: SET_SUCCESS,
        payload: invoicesSelector.createdInvoiceAssignment.message
      })
      dispatch(clearCreatedInvoiceAssignment())
      setAssigningInvoice(false)
    }

    return () => {
      
    };
  }, [dispatch, invoiceId, invoicesSelector.createdInvoiceAssignment, invoicesSelector.updatedInvoice]);
  
  const [editingInvoice, setEditingInvoice] = useState(false);
  const [assigningInvoice, setAssigningInvoice] = useState(false);

  const searchStudents = debounce((term) => {
      if(!term || term === '') {
        dispatch(fetchInvoiceAssignments(``, 1, 10))
      }
      dispatch(fetchInvoiceAssignments(`searchTerm=${term}`, 0, 0))
  })

  const [activeInvoiceAssignment, setActiveInvoiceAssignment] = useState(null);

  const [enablingPartPayment, setEnablingPartPayment] = useState(false)
  
  const openEnablingPartPayment = (assignment) => {
    setActiveInvoiceAssignment(null)
    setEnablingPartPayment(true)
    setTimeout(() => {
      setActiveInvoiceAssignment(assignment)
    }, 300);
  }

  const [addingDiscount, setAddingDiscount] = useState(false)

  const openAddignDiscount = (assignment) => {
    setActiveInvoiceAssignment(null)
    setAddingDiscount(true)
    setTimeout(() => {
      setActiveInvoiceAssignment(assignment)
    }, 300);
  }

  return (
    <div className='w-full'>
      {loading ? 
        <div className='w-full'>
          <Loader />
        </div>

        :

        <>
          <div className='py-3 mb-2'>
            <div className="w-full mx-auto">
                <div className='w-full flex items-center justify-between'>
                    <div className='w-2/3'>
                        <h4 className='font-medium text-lg text-gray-400'>Invoice Details</h4>
                        <div className=''>
                            <p className='text-gray-500 mt-1 text-sm'>
                                Below are the details of the invoice.
                            </p>
                        </div>
                    </div>
                    <div className='flex-row-reverse flex gap-x-[5px]'>
                      <button onClick={()=>{setAssigningInvoice(true)}} className='rounded-[8px] px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                        Assign Invoice
                      </button>
                      <button onClick={()=>{setEditingInvoice(true)}} className='rounded-[8px] p-3 mt-4 text-sm text-gray-600 bg-gray-100 transition duration-200 border border-gray-100 hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                        <PencilSquareIcon className={`w-5 h-5`} />
                        {/* Edit Invoice */}
                      </button>
                      <button onClick={()=>{setEditingInvoice(true)}} className='rounded-[8px] p-3 mt-4 text-sm text-gray-600 bg-gray-100 transition duration-200 border border-gray-100 hover:bg-red-100 hover:text-red-600 flex items-center justify-center gap-x-2'>
                        <TrashIcon className={`w-5 h-5`} />
                        {/* Delete Invoice */}
                      </button>
                    </div>
                </div>
            </div>
          </div>

          <div className='w-full flex items-stretch justify-between gap-x-[20px] mt-[40px]'>
            <div className='w-8/12'>
              <div className='flex items-start justify-between'>
                <div className='w-full mb-[10px]'>
                  <p className='text-xs text-gray-400 mb-[5px]'>Name</p>
                  <h3 className='font-[500] text-black text-lg'>{invoiceDetails.name}</h3>

                  <div className='mt-[10px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                    <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p>
                  </div>

                  {invoiceDetails.scholarshipsApply && <div className='mt-[20px]'>
                    <span className='font-space-grotesk font-medium text-sm p-[10px] bg-green-500 bg-opacity-10 rounded text-green-600'>Scholarships Apply</span>
                  </div>}
                </div>
                <div className='w-full mb-[10px]'>
                  <div>
                    <p className='text-xs text-gray-400 mb-[5px]'>Invoice Code</p>
                    <p className='font-[500] text-xl font-space-grotesk text-black'>{invoiceDetails.invoiceCode}</p>
                  </div>
                  {/* <div className='mt-[10px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                    <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p>
                  </div> */}
                </div>
              </div>
              <div className='flex items-start justify-between mt-[20px]'>
                <div className='w-full mb-[10px]'>
                  <p className='text-xs text-gray-400 mb-[5px]'>Invoice Total</p>
                  <h3 className='font-[500] text-black text-4xl'>₦{(invoiceDetails.total/100).toLocaleString()}</h3>
                </div>
                <div className='w-full mb-[10px]'>
                  {/* <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                  <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p> */}
                </div>
              </div>

              <div className='w-full pt-[20px] border-t mt-[40px]'>
                <div className='w-full mb-[10px]'>
                  <h3 className='text-gray-600 mb-[5px] font-[550]'>Fees (all fees that make up this invoice)</h3>

                  <div className='w-full mt-[20px] flex items-center justify-between mb-[10px] p-[5px] bg-gray-100'>
                    <div className='w-6/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Fee</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Rate</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Quantity</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Subtotal</p>
                    </div>
                  </div>
                  {invoiceDetails.fees.map((fee, feeIndex)=>(<div key={feeIndex} className='w-full mt-[20px] flex items-start justify-between p-[5px] gap-x-[10px] border-b'>
                    <div className='w-6/12'>
                      <p className='text-gray-700 mb-[5px]'>{fee.fee.name}</p>
                      <p className='text-gray-500 text-sm mb-[5px]'>{fee.fee.description}</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px]'>{(fee.fee.amount/100).toLocaleString()}</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-gray-700 mb-[5px]'>{fee.quantity}</p>
                    </div>
                    <div className='w-2/12'>
                      <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px]'>{((fee.fee.amount/100) * fee.quantity).toLocaleString()}</p>
                    </div>
                  </div>))}
                </div>
              </div>
            </div>
            <div className='w-4/12 min-h-[700px] bg-gray-50 p-[20px]'>
              <h3 className='text-gray-600 mb-[5px] font-[550] border-b w-full pb-[10px] border-gray-600'>Assignments & Payments</h3>
              <div className='w-full mt-[20px]'>
                <SearchField 
                    placeholderText={`Search assignments by student name`}
                    showResultsDropDown={false}
                    triggerSearch={(term)=>{searchStudents(term)}}
                    performingSearch={invoicesSelector?.loadingInvoiceAssignments}
                />
              </div>
              {invoicesSelector?.loadingInvoiceAssignments ? 
                <Loader /> :
                <>
                  {invoicesSelector.invoiceAssignments?.assignments?.length > 0 ?
                    <div className='w-full mt-[20px]'>
                      {invoicesSelector.invoiceAssignments?.assignments?.map((assignment, assignmentIndex)=>(
                        <div onClick={()=>setActiveInvoiceAssignment(assignment)} key={assignmentIndex} className='mb-[15px] cursor-pointer'>
                          <InvoiceAssignmentCard assignment={assignment} />
                        </div>
                      ))}

                      <button onClick={()=>{}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>See all assignments for this invoice <ArrowIcon className={`w-4 h-4`} /></button>
                    </div>
                    :
                    <div className='w-full p-[20px] mt-[20px]'>
                      <EmptyState emptyStateText={`No assignments available for this invoice yet. Click on "Assign invoice" above to assign the invoice`} />
                    </div>
                  }
                </>
              }
            </div>
          </div>

          <ModalDialog
            shown={editingInvoice} 
            closeFunction={()=>{setEditingInvoice(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Update invoice'
            maxWidthClass='max-w-4xl'
            hideActions={true}
          >
            <EditInvoice invoice={invoiceDetails} closeFunction={()=>{setEditingInvoice(false)}} />
          </ModalDialog>

          <ModalDialog
            shown={assigningInvoice} 
            closeFunction={()=>{setAssigningInvoice(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle={`Assign Invoice - ${invoiceDetails.name}`}
            maxWidthClass='max-w-3xl'
            hideActions={true}
          >
            <AssignInvoice invoice={invoiceDetails} closeFunction={()=>{setAssigningInvoice(false)}} />
          </ModalDialog>


          {activeInvoiceAssignment && <ModalDialog
            shown={activeInvoiceAssignment !== null && !enablingPartPayment && !addingDiscount} 
            closeFunction={()=>{setActiveInvoiceAssignment(null)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Invoice Details'
            maxWidthClass='max-w-4xl'
            hideActions={true}
          >
            <AssignedInvoice 
                assignment={activeInvoiceAssignment}
                invoiceId={activeInvoiceAssignment.invoice._id} 
                closeFunction={()=>{setActiveInvoiceAssignment(null)}} 
                startAddDiscount={(assignment)=>{openAddignDiscount(assignment)}}
                startEnablePartPayment={(assignment)=>{openEnablingPartPayment(assignment)}}
            />
          </ModalDialog>}

          {activeInvoiceAssignment && <ModalDialog
            shown={activeInvoiceAssignment !== null && enablingPartPayment} 
            closeFunction={()=>{setEnablingPartPayment(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Enable Part payments'
            maxWidthClass='max-w-lg'
            hideActions={true}
          >
            <EnablePartPayment 
                assignment={activeInvoiceAssignment}
                closeFunction={()=>{setEnablingPartPayment(false)}}
            />
          </ModalDialog>}

          {activeInvoiceAssignment && <ModalDialog
            shown={activeInvoiceAssignment !== null && addingDiscount} 
            closeFunction={()=>{setAddingDiscount(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Add a discount'
            maxWidthClass='max-w-lg'
            hideActions={true}
          >
            <AddInvoiceDiscount
                assignment={activeInvoiceAssignment}
                closeFunction={()=>{setAddingDiscount(false)}} 
            />
          </ModalDialog>}
        </>

      }
    </div>
  )
}

export default Invoice